export const BASE_URL = process.env.REACT_APP_BASE_URL_PROBLEM!!
export const BASE_URL_AUTH = process.env.REACT_APP_BASE_URL_AUTH!!
export const BASE_URL_DASHBOARD = process.env.REACT_APP_BASE_URL_DASHBOARD!!
export const BASE_URL_ASSET = process.env.REACT_APP_BASE_URL_ASSET_MANAGEMENT!!
